var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-box"},[_c('img',{attrs:{"src":require("../../../../static/images/img_no_permission.png"),"alt":""}}),_c('div',[_c('span',[_vm._v("哎呀...您暂时没有权限访问该页面")]),_c('el-button',{attrs:{"icon":"el-icon-s-home"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }